<template>
	<page>
		<module title="店铺资料">
			<c-form ref="form">
				<c-title>基本信息</c-title>
				<c-form-item label="商家名称" tip="此处不支持更改,如需更改请联系平台运营方">
					<c-input name="company_name" disabled></c-input>
				</c-form-item>
				<c-form-item label="店铺名称" tip="此处不支持更改,如需更改请联系平台运营方">
					<c-input name="shop_name"  maxlength="50" disabled></c-input>
				</c-form-item>
				<c-form-item label="LOGO图片" required width="800">
					<c-upload-file name="logo_img" media type="image" tip="请上传一张商家LOGO图片，建议尺寸160×160px"></c-upload-file>
				</c-form-item>
				<c-form-item label="店铺介绍" required v-show="systemConfig.station_shop_content_enabled == 'ON'">
					<c-input name="shop_content" type="textarea" maxlength="200" heightResize="auto"></c-input>
				</c-form-item>
				<c-form-item label="默认发货地" v-show="false">
					<!-- <c-region province-name="delivery_province_id" city-name="delivery_city_id" level="2" disabled></c-region> -->
					<c-input name="delivery_names"  maxlength="50" disabled></c-input>
					<template #tip>
						如需修改请前往：物流工具--><c-link href="/logistics_tool?tab=0">发货地址管理</c-link>
					</template>
				</c-form-item>
				<!-- <c-title v-show="userInfo.stationed_type==1">横幅图片</c-title> -->
				<!-- <c-form-item label="PC端横幅图片" required width="800" v-show="userInfo.stationed_type==1" > -->
					<!-- <c-upload-file name="pc_banner_img_list" media multiple="5" type="image" tip="请上传最多5张banner图片，建议尺寸3840×900px(高清)，或者1920×450px"></c-upload-file> -->
				<!-- </c-form-item> -->
				<!-- <c-form-item label="移动端横幅图片" required width="800" v-show="userInfo.stationed_type==1" > -->
					<!-- <c-upload-file name="app_banner_img_list" media multiple="5" type="image" tip="请上传最多5张banner图片，建议尺寸750×440px"></c-upload-file> -->
					<!-- <c-upload-file name="app_banner_img_list" media  type="image" tip="建议尺寸750×440px"></c-upload-file> -->
				<!-- </c-form-item> -->
				<c-title>客服信息</c-title>
				<c-form-item label="客服电话">
					<c-input name="service_phone"></c-input>
				</c-form-item>
				<!-- <c-form-item label="投诉电话" required>
					<c-input name="complaint_phone"></c-input>
				</c-form-item> -->
				<!-- <c-form-item label="客服二维码图片" width="800">
					<c-upload-file name="service_image" media type="image" tip="建议尺寸300×300px"></c-upload-file>
				</c-form-item> -->
                <c-form-item label="在线客服欢迎语" tip="不填写欢迎语则使用系统默认欢迎语">
                    <c-input type="textarea" name="welcome_message" maxlength="200" heightResize="auto" ></c-input>
                </c-form-item>
                <c-form-item label="是否开启电话通知" tip="客户在线咨询后，超过一定时间后服务商仍未读，直接电话通知服务商" required>
                    <c-radio-group name="phone_notice_flag" v-model="phoneNoticeFlag" :options="phoneNoticeFlagOption" ></c-radio-group>
                </c-form-item>
                <c-form-item v-show="phoneNoticeFlag == 1" label="消息未读超期时间" tip="客户在线咨询后，超过XX分钟服务商仍未读，直接电话通知服务商" required>
                    <c-input type="number" decimal="0" :range="[3,1440]" name="phone_notice_overdue" unit="分钟"></c-input>
                </c-form-item>
                <c-form-item v-show="phoneNoticeFlag == 1" label="每日电话通知时间" tip="每日仅在该时间段内才会收到电话通知" required>
                    <c-datetime start-name="phone_notice_start_time" end-name="phone_notice_end_time" type="time" range></c-datetime>
                </c-form-item>
				<c-title v-show="userInfo.stationed_type==2 && userInfo.platform_user_id!=0">转单配置</c-title>
				<c-form-item v-show="userInfo.stationed_type==2  && userInfo.platform_user_id!=0" label="是否开启自动转单" tip="如果开启，零售订单支付完成后，会自动创建代发订单" required>
					<c-radio-group name="dropshipping_auto_trandfer" v-model="dropshipping_auto_trandfer">
						<c-radio value="0">关闭</c-radio>
						<c-radio value="1">开启</c-radio>
					</c-radio-group>
				</c-form-item>
				<c-form-item v-show="this.systemConfig.account_balance_enabled  == 'ON' && this.dropshipping_auto_trandfer==1 && userInfo.stationed_type==2  && userInfo.platform_user_id!=0" label="是否开启自动支付" tip="【仅开启自动转单后生效】如果开启，用户余额充足时，转单完成的代发单将自动使用余额支付" required>
					<c-radio-group name="dropshipping_auto_pay">
						<c-radio value="0">关闭</c-radio>
						<c-radio value="1">开启</c-radio>
					</c-radio-group>
				</c-form-item>
                <c-title>规则配置</c-title>
                <c-form-item label="服务排序规则" tip="店铺主页服务列表默认排序" required>
                    <c-select name="product_sort_rule" :options="product_sort_rules"></c-select>
                </c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button color="main" size="form" @click="submit()">保存资料</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		props: {
			
		},
		
		data() {
			return {
				shopDetail:{},
				dropshipping_auto_trandfer:1, /**0:关闭  1:开启*/
                product_sort_rules: [
                    {
                        value: '1',
                        name: '按发布时间最新在前'
                    },
                    {
                        value: '2',
                        name: '按发布时间最新在后'
                    },
                    {
                        value: '3',
                        name: '按价格由高到低'
                    },
                    {
                        value: '4',
                        name: '按价格由低到高'
                    },
                    {
                        value: '5',
                        name: '按销量由高到低'
                    },
                    {
                        value: '6',
                        name: '按销量由低到高'
                    },
                ],
                phoneNoticeFlag:0,//0=关闭  1=开启
                phoneNoticeFlagOption:[
                    {
                        name: '关闭',
                        value: 0
                    }, {
                        name: '开启',
                        value: 1
                    }
                ]
            }
		},
		
		computed: {
			...mapState(['userInfo','systemConfig'])
		},
		
		watch: {
			
		},
		
		mounted() {
			this.getShopDetail();
		},
		
		methods: {
			getShopDetail() {
				this.request({
					url: '/stationed/shop/info',
					data: {},
					loading: true,
					success: data => {
						this.shopDetail = data;
						this.dropshipping_auto_trandfer = data.dropshipping_auto_trandfer||0;
						// if(data.pc_banner_img_list){
						// 	data.pc_banner_img_list = Array.from(data.pc_banner_img_list.split(','))
						// }
						//data.delivery_names = data.delivery_province_name +' '+ data.delivery_city_name;
						if(data.app_banner_img_list){
							data.app_banner_img_list = Array.from(data.app_banner_img_list.split(','))
						}
                        this.phoneNoticeFlag = data.phone_notice_flag||0;
						this.$refs.form.set(data);
					}
				});
			},
			
			submit(type) {
				this.$refs.form.submit({
					url: '/stationed/shop/edit',
					rule: {
						shop_name: '请填写店铺名称',
                        logo_img: '请上传店铺LOGO',
						shop_content: '写一点店铺介绍吧，让客户更好的了解你们',
                        product_sort_rule:'请选择服务默认排序规则',
                        phone_notice_overdue: [{
                            type: 'empty',
                            skip: () => {
                                return this.phoneNoticeFlag == 0;
                            },
                            message: '请输入超期电话通知时间'
                        }],
                        phone_notice_start_time: [{
                            type: 'empty',
                            skip: () => {
                                return this.phoneNoticeFlag == 0;
                            },
                            message: '请选择每日电话通知开始时间'
                        }],
                        phone_notice_end_time: [{
                            type: 'empty',
                            skip: () => {
                                return this.phoneNoticeFlag == 0;
                            },
                            message: '请选择每日电话通知结束时间'
                        }],
						// app_banner_img_list: [{
						// 	type: 'function',
						// 	fun: value => {
						// 		if(this.userInfo.stationed_type == 2){
						// 			return true;
						// 		}
						// 		return value.length;
						// 	},
						// 	message: '请上传一张移动端Banner图片'
						// }],
						// app_banner_img_list: [{
						// 	type: 'function',
						// 	fun: value => {
						// 		return value.length;
						// 	},
						// 	message: '请至少上传一张移动端Banner图片'
						// }],
						// service_phone: '请填写客服电话',
						// complaint_phone: '请填写投诉电话'
					},
					
					dataFormatter: data => {
						//console.log(data)
						//data.pc_banner_img_list = data.pc_banner_img_list.join(',');
						//data.app_banner_img_list = data.app_banner_img_list.join(',');
						return data;
					},
					
					success: (data, param) => {
						this.$message({
							message: '保存成功'
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>